import React, {useContext, useEffect, useRef, useState} from 'react';
import {InputText} from "primereact/inputtext";
import callToast, {postData, validateFormFields} from "../../../../utils/helper";
import {useFetch} from "../../../../layout/hooks/useFetch";
import {Button} from "primereact/button";
import {webInfo} from "../../../../utils/webInfo";
import {Toast} from "primereact/toast";
import {LayoutContext} from "../../../../layout/context/LayoutContext";

const UserInfo = ({activeIndex}: { activeIndex: number }) => {
    const initialState = {
        name: '',
        email: '',
    }
    const [formData, setFormData] = useState(initialState)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false)
    const [isDirty, setIsDirty] = useState(false);
    const toastRef = useRef<Toast | null>(null);
    const {accessToken } = useContext(LayoutContext)

    const {data: userData} = useFetch('/profile', [refresh], true, activeIndex === 0)
    const submitFormEndpointUrl = '/profile'

    useEffect(() => {
        if (userData) {
            setFormData({
                name: userData?.name,
                email: userData?.email,
            });
            setIsDirty(false); // Reset dirty state on fetch
        }
    }, [userData]);

    // Track changes to form fields
    const handleInputChange = (field: string, value: string) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        setIsDirty(true);
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const validationRules = [
            { field: 'name', label: 'Name' },
            { field: 'email', label: 'Email' },
        ];

        if (!validateFormFields(formData, validationRules, toastRef)) return;

        const payload =  {
            name: formData.name.replace(/\s+/g, ' ').trim(),
            email: formData.email.replace(/\s+/g, ' ').trim()
        };

        try {
            setIsSubmitting(true);
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData("PUT", accessToken, payload));

            if (response.ok) {
                callToast(toastRef, true, `Profile updated successfully`);
                setFormData(initialState)
                setRefresh(!refresh);
                return;
            }else{
                const resData = await response.json();
                callToast(toastRef, false, resData.error);
            }

        } catch (err) {
            console.error('Failed to update', err);
        }finally {
            setIsSubmitting(false);
        }

    }


    return (
        <form onSubmit={handleSubmit}>
            <Toast ref={toastRef}/>

            <div className="grid">
                <div className="col-12 md:col-3">
                    <p className="mb-2 font-light text-sm text-600">Email</p>
                    <InputText
                        id="email"
                        value={formData.email}
                        onChange={(e) => handleInputChange('email', e.target.value)}
                        placeholder={"Enter email"}
                        className={`w-full`}
                        type="email"
                    />
                </div>
            </div>
            <div className="grid">
                <div className="col-12 md:col-3">
                    <p className="mb-2 font-light text-sm text-600">Name</p>
                    <InputText
                        id="name"
                        value={formData.name}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                        placeholder={"Enter name"}
                        className={`w-full`}
                        type="text"
                    />
                </div>
            </div>


            <div className="flex gap-2 mt-2">
                <Button
                    type="submit"
                    label={'Update' }
                    className="p-button-primary"
                    loading={isSubmitting}
                    size={'small'}
                    outlined
                    disabled={!isDirty}
                />
            </div>
        </form>

    );
};

export default UserInfo;